// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"213":"76475a67","594":"52d627fb","833":"8374b1c0"}[chunkId] + ".js";
};